export class MediaModel {
  auxilaryMedia: string;
  largeImageUrl: string;
  smallImageUrl: string;
  thumbnailurl: string;
  smallThumbnailUrl: string;
  benefitsImageUrl: string;
  benefitsSmallImageUrl: string;

  constructor() {
    this.auxilaryMedia = undefined;
    this.largeImageUrl = undefined;
    this.smallImageUrl = undefined;
    this.thumbnailurl = undefined;
    this.smallThumbnailUrl = undefined;
    this.benefitsImageUrl = undefined;
    this.benefitsSmallImageUrl = undefined;
  }
}
